import * as React from 'react';
import { useHistory } from 'react-router-dom';
import PageLayout from 'global_elements/Layouts/PageLayout';
import { PageLayoutVariant } from 'global_elements/Layouts/PageLayout/variants';
import { ExecutiveRoutes } from 'constants/routes';

const FacilityExecutiveDashboardPage = (): React.JSX.Element => {
  const history = useHistory();

  React.useEffect(() => {
    history.push(ExecutiveRoutes.REPORTS);
  }, []);

  return (
    <PageLayout layout={PageLayoutVariant.PADDED} testText="Facility Executive Dashboard Page" title="Facility Executive Dashboard">
      Redirecting...
    </PageLayout>
  );
};

export default FacilityExecutiveDashboardPage;
